module.exports = __webpack_public_path__ + "img/work_a.d637296b.png";